import React from "react";
import { DateTime } from "luxon";
import Alert from "@mui/material/Alert";
import { Now } from "../core/Now";
import { useMyProfile } from "@seabrookstudios/pitch2table";

/**
 * @param {object} props
 * @param {string|undefined} props.timezone
 */
export const PublisherTimezoneWarning = ({ timezone }) => {
  const { data: profile } = useMyProfile();

  if (!timezone) {
    return null;
  }

  const localTime = DateTime.now().setZone(timezone);

  if (!localTime.isValid) {
    return null;
  }

  const isOutsideBusinessHours = localTime.hour < 9 || localTime.hour >= 17 || localTime.weekday > 5;

  if (!isOutsideBusinessHours) {
    return null;
  }

  return (
    <Alert severity="warning">
      Publisher local time of{" "}
      <Now timezone={timezone} formattingTimezone={profile?.location?.timezone} component="span" /> is outside regular
      business hours.
    </Alert>
  );
};
